const initialState = {
	'size': 20,
	'lockScreen': false,
	'decimalPoint': 2,
	'currencyId': '',
	'posId': '',
	'organizationId': '',
	'rememberLastDocumentInPreview': null,
	// Izlash maydoniga yozilgan matnni sahifadan chiqib qaytganda ham saqlab qolish.
	'saveSearch': false,
	// Narx yorlig'i konstruktorining maketlari: { '30x20': {...}, '58x40': {...} }
	// va foydalanuvchi qo'shgan ixtiyoriy o'lchamlar: [{ w: 58, h: 40 }]
	'priceTagLayouts': {},
	'priceTagSizes': [],
	// Narxlar sahifasidagi "Sozlamalar" toggle'lari (A4, sana, ulgurji narx ...) --
	// sahifadan chiqib qaytganda ham saqlanib qolishi uchun.
	'priceTagOptions': {
		'activatePrice': 0,
		'activeA4': false,
		'activeDate': false,
		'activeOldPrice': false,
		// Shtrix-kod ko'rinishi: 'auto' (EAN-13/CODE128) yoki 'code128' (hammasi bir xil).
		'barcodeMode': 'auto',
	},
	'documentsInCreate': {
		'name': true,
		'barcode': true,
		'balance': true,
		'quantity': true,
		'uomName': true,
		'price': true,
		'wholesalePrice': true,
		'salePrice': true,
		'serial': true,
		'expDate': true,
		'vat': true,
	},
	'tableControl': {
		'nomenclature': {
			'index': {
				'posName': true,
				'productName': true,
				'organizationName': true,
				'barcode': true,
				'price': true,
				'wholesalePrice': true,
				'salePrice': true,
				'currencyName': true,
				'serial': true,
				'expDate': true,
				'balance': true,
			}
		}
	},
}

const settings = function (state = initialState, action) {
	switch (action.type) {
		case "SET_SETTINGS":
			return action.payload;
		case "SET_PAGINATION_SIZE":
			return { ...state, 'size': action.payload };
		case "SET_DECIMAL_POINT":
			return { ...state, 'decimalPoint': action.payload };
		case "SET_DOCUMENTS_IN_CREATE":
			return { ...state, 'documentsInCreate': action.payload };
		case "SET_REMEMBER_LAST_DOCUMENTIN_PREVIEW":
			return { ...state, 'rememberLastDocumentInPreview': action.payload };
		case "SET_PRICE_TAG_LAYOUTS":
			return { ...state, 'priceTagLayouts': action.payload };
		case "SET_PRICE_TAG_SIZES":
			return { ...state, 'priceTagSizes': action.payload };
		case "SET_PRICE_TAG_OPTIONS":
			return { ...state, 'priceTagOptions': action.payload };
		case "SET_LOCK_SCREEN":
			return { ...state, 'lockScreen': true };
		case "SET_UNLOCK_SCREEN":
			return { ...state, 'lockScreen': false };
		default:
			return state;
	}
};

export default settings